import type { LlmModel } from '@saaga/shared/interfaces/llm-model.interface'

export const filterModelBySearch = (model: LlmModel, search: string): boolean => {
  const searchLower = search.toLowerCase()
  const matchesName = model.name.toLowerCase().includes(searchLower)
  const matchesId = model.id.toLowerCase().includes(searchLower)
  return matchesName || matchesId
}

export const createModelFilter = (
  modelList: LlmModel[]
): ((itemValue: string, search: string) => number) => {
  return (itemValue: string, search: string): number => {
    const model = modelList.find((m) => m.id === itemValue)
    if (!model) return 0
    return filterModelBySearch(model, search) ? 1 : 0
  }
}
